
const backgroundStyle = {
  values: [0, 1, 2, 3, 4],
  labels: ['Default', 'Color', 'Image', 'CubeMap', 'EnvironmentMap'],
};

const Environment = {
  schema: {
    ambientLight: { label: 'Color', type: 'Color', defaultValue: { r: 0, g: 0, b: 0 } },
    environmentMap: { label: 'Environment Map', type: 'Plug', plug: 'Material' },

    backgroundStyle: { label: 'Style', type: 'Options', defaultValue: 0, values: backgroundStyle.values, labels: backgroundStyle.labels },
    backgroundColor: { label: 'Color', type: 'Color', defaultValue: { r: 0, g: 0, b: 0 } },
    backgroundOpacity: { label: 'Opacity', type: 'Number', defaultValue: 1, minValue: 0, maxValue: 1, step: 0.1 },

    background: { label: 'Image', type: 'Plug', plug: 'Image' },

    cubeMapBlurring: { label: 'CubeMap Blur', type: 'Number', defaultValue: 0, minValue: 0, maxValue: 10, step: 0.5, animatable: true },
    cubeMap: { label: 'CubeMap', type: 'Plug', plug: 'Material' },
  },
};

export default { Environment };



// WEBPACK FOOTER //
// ./src/operators/Environment.js